import { Navigate, useLocation } from "react-router";
import { useSelector } from "react-redux";
import { LOGIN_PATH, NOACCESS } from "../constants/routes";
import { checkHierarchyAuthorization } from "../utils/commonUtils";
import { getPostLoginReturnUrl } from "../utils/postLoginRedirect";
import ExternalRedirect from "./ExternalRedirect";

const PrivateRoute = ({ children }) => {
    const { userData } = useSelector(state => state.auth);
    const location = useLocation();
    const isLoggedIn = userData?.UserId;
    if (!isLoggedIn) return <Navigate to={LOGIN_PATH} state={{ from: location }} replace />;
    // Google/Okta/SAML callbacks land on "/" after login; finish a login started from the user manual.
    const returnUrl = getPostLoginReturnUrl();
    if (returnUrl) return <ExternalRedirect to={returnUrl} />;
    if (!checkHierarchyAuthorization(userData)) return <Navigate to={NOACCESS} state={{ from: location }} replace />;
    // else if (!hasValidRole) return <Navigate to="/noaccess" replace />;
    return children;
};

export default PrivateRoute